import logo from './img/logo_1.png';
import './App.css';
import Home from "./components/Home";
import Clients from "./components/Clients"
import Login from "./components/Login";
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import Budgeting from './components/Budgeting';
import ClaimTickets from './components/ClaimTickets';
import Inventory from './components/Inventory';
import Catalogue from './components/Catalogue';
import { useNavigate } from 'react-router-dom';
import Users from './components/Users.js';
import { AuthProvider, useAuth } from "./components/AuthProvider";
import ProtectedRoute from './components/ProtectedRoute.js';
import Userdd from './components/Userdd.js';
import NotFound from './components/NotFound.js';
import Process from './components/Process.js'

const Header = () => {
  const { isAuthenticated, logout , user} = useAuth(); // Get authentication state and logout function
  const navigate = useNavigate(); // Initialize useNavigate
  return (
    <header>
      <div className="header-logo">
        <Link to="/home">
          <img src={logo} alt="Logo" />
        </Link>
      </div>
      <div className="header-signin">
        {isAuthenticated && user ? ( // Show "Sign Out" if logged in
          <Userdd username={user["usuario"] || user["email"] || 'Usuario'}>
          </Userdd>
        ) : (
          <Link to="/login" className="signin-link">Sign In</Link> // Show "Sign In" if not logged in
        )}
      </div>
    </header>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <div>
          <Header /> {/* Include the Header component */}
          <div>
            <Routes>
              {/* Login Route (without Sidebar) */}
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              
              {/* Protected Routes with Main Layout (with Sidebar) */}
              <Route
                path="/home"
                element={
                  <ProtectedRoute>
                    <MainLayout>
                      <Home />
                    </MainLayout>
                  </ProtectedRoute>
                }
              />
              
              <Route
                path="/clientes"
                element={
                  <ProtectedRoute access_requirement={"acceso_clientes"}>
                    <MainLayout>
                      <Clients />
                    </MainLayout>
                  </ProtectedRoute>
                }
              />
              
              <Route 
                path="/cotizaciones" 
                element={
                  <ProtectedRoute access_requirement={"acceso_cotizaciones"}>
                    <MainLayout>
                      <Budgeting />
                    </MainLayout>
                  </ProtectedRoute>
                }
              />
              
              <Route
                path="/inventario"
                element={
                  <ProtectedRoute access_requirement={"acceso_inventario"}>
                    <MainLayout>
                      <Inventory />
                    </MainLayout>
                  </ProtectedRoute>
                }
              />
              
              <Route
                path="/catalogo"
                element={
                  <ProtectedRoute access_requirement={"acceso_catalogo"}>
                    <MainLayout>
                      <Catalogue />
                    </MainLayout>
                  </ProtectedRoute>
                }
              />
              
              <Route
                path="/notasrecepcion"
                element={
                  <ProtectedRoute access_requirement={"acceso_notas_recepcion"}>
                    <MainLayout>
                      <ClaimTickets />
                    </MainLayout>
                  </ProtectedRoute>
                }
              />
              
              <Route
                path="/usuarios"
                element={
                  <ProtectedRoute access_requirement={"acceso_usuarios"}>
                    <MainLayout>
                      <Users />
                    </MainLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/proceso"
                element={
                  <ProtectedRoute access_requirement={"acceso_proceso"}>
                    <MainLayout>
                      <Process />
                    </MainLayout>
                  </ProtectedRoute>
                }
              />

              {/* 404 Route - Catch all unmatched routes */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
